import { useAbility } from '@casl/vue'
import type { AppAbility } from '~/auth/abilities'

export const useAppAbility = () => useAbility<AppAbility>()
